"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const providerList_1 = tslib_1.__importDefault(require("../../providerList"));
const UserPublicDataProvider_1 = require("./UserPublicDataProvider");
const ContentFeedProvider_1 = require("./ContentFeedProvider");
const EventPostProvider_1 = require("./EventPostProvider");
const DiscoveryVisibilityProvider_1 = require("./DiscoveryVisibilityProvider");
const PerformerListProvider_1 = require("./PerformerListProvider");
const PostVerificationProvider_1 = require("./PostVerificationProvider");
exports.default = Object.assign(Object.assign({}, providerList_1.default), { UserPublicDataProvider: UserPublicDataProvider_1.UserPublicDataProvider,
    ContentFeedProvider: ContentFeedProvider_1.ContentFeedProvider,
    EventPostProvider: EventPostProvider_1.EventPostProvider,
    DiscoveryVisibilityProvider: DiscoveryVisibilityProvider_1.DiscoveryVisibilityProvider,
    PerformerListProvider: PerformerListProvider_1.PerformerListProvider,
    PostVerificationProvider: PostVerificationProvider_1.PostVerificationProvider });
//# sourceMappingURL=index.js.map